const routes = {
  LOCATION_DETECTION: '/',
  THANK_YOU: '/thank-you',
};

export default routes;
